/**
 * Valori di {{nome}} e {{azienda}} per i modelli, dal Lead/Cliente abbinato alla chat
 * (whatsapp_chat_assignments.client_id). Chat senza abbinamento: nessun valore, le
 * variabili restano da compilare a mano.
 */

import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { clientTemplateVars, type ClientVars } from './quickReplies';

const cache = new Map<string, ClientVars>();

export function useLinkedClientVars(clientId: string | null): ClientVars {
  const [vars, setVars] = useState<ClientVars>(() => (clientId && cache.get(clientId)) || {});

  useEffect(() => {
    if (!clientId) { setVars({}); return; }
    const cached = cache.get(clientId);
    if (cached) { setVars(cached); return; }
    let cancelled = false;
    supabase
      .from('clients')
      .select('business_name, contact_name, entity_type')
      .eq('id', clientId)
      .maybeSingle()
      .then(({ data }) => {
        const v = clientTemplateVars(data);
        cache.set(clientId, v);
        if (!cancelled) setVars(v);
      });
    return () => { cancelled = true; };
  }, [clientId]);

  return vars;
}
